var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',[_c('v-btn',{attrs:{"text":"","color":"brand"},on:{"click":_vm.goToDashboard}},[_c('v-icon',[_vm._v("arrow_left")]),_vm._v("Training Dashboard")],1)],1)],1),_c('v-row',[_c('v-col',[_c('TrainingItems',{attrs:{"categoryId":_vm.categoryId}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }